// Форматирането на времената в справка „Монитори".
//
// Продължителността се пази и като число (секунди) в самата колона — тук се
// прави само четимият надпис, за да не подрежда таблицата по текст.

import dayjs from "dayjs";

import { EM_DASH } from "../../../../components/dataTable";

/**
 * „45s" под минута, „4m 05s" над нея.
 *
 * Форматът идва едно към едно от стария екран и НЕ се пипа: по него се сверяват
 * вече отпечатани и изнесени справки.
 *
 * `null` е ЛИПСВАЩ статус (редът не е минал през него), а не нула секунди —
 * рисува се с тире.
 */
export const formatDuration = (
  seconds: number | null | undefined,
): string => {
  if (seconds === null || seconds === undefined || !Number.isFinite(seconds)) {
    return EM_DASH;
  }
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  if (minutes === 0) return `${rest}s`;
  return `${minutes}m ${String(rest).padStart(2, "0")}s`;
};

/**
 * Моментът на реда — час:минута:СЕКУНДА.
 *
 * Секундите остават: разликите между два реда в кухнята често са под минута и
 * без тях две различни поръчки изглеждат влезли в един и същи момент.
 *
 * Часът е 24-часов през dayjs, а НЕ през `toLocaleTimeString(language)`: така
 * клетката съвпада с Excel файла на същата справка и с всяка друга времева
 * клетка в модула (`formatDateTime`). С локала английският потребител виждаше
 * „01:23:45 PM" на екрана и „13:23:45" в експорта.
 */
export const formatMoment = (iso: string | null | undefined): string => {
  if (!iso) return EM_DASH;
  const parsed = dayjs(iso);
  return parsed.isValid() ? parsed.format("HH:mm:ss") : EM_DASH;
};
